import { NavLink } from 'react-router-dom'
import { 
  LayoutDashboard, 
  ShoppingBag, 
  Users, 
  Grid3x3, 
  CreditCard, 
  Package, 
  Tag,
  Shield,
  X,
  ChevronLeft
} from 'lucide-react'
import { useSidebarStore } from '@/stores/useSidebarStore'
import { cn } from '@/utils/cn'

const navigation = [
  { name: 'Dashboard', href: '/', icon: LayoutDashboard },
  { name: 'Orders', href: '/orders', icon: ShoppingBag },
  { name: 'Customers', href: '/customers', icon: Users },
  { name: 'Categories', href: '/categories', icon: Grid3x3 },
  { name: 'Transactions', href: '/transactions', icon: CreditCard },
  { name: 'Add Product', href: '/products/add', icon: Package },
  { name: 'Discounted Coupon', href: '/discounted-coupon', icon: Tag },
  { name: 'Admin Role', href: '/admin/role', icon: Shield },
]

export default function Sidebar() {
  const { isOpen, isMobile, setOpen } = useSidebarStore()

  return (
    <>
      {/* Mobile overlay */}
      {isMobile && isOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setOpen(false)}
        />
      )}
      
      {/* Sidebar */}
      <div className={cn(
        'fixed inset-y-0 left-0 z-50 w-64 bg-card border-r transform transition-transform duration-200 ease-in-out lg:fixed lg:translate-x-0',
        isOpen ? 'translate-x-0' : '-translate-x-full',
        !isOpen && 'lg:w-16'
      )}>
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b">
            {isOpen && (
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                  <span className="text-primary-foreground font-bold text-sm">T</span>
                </div>
                <span className="font-semibold text-lg">Thredz</span>
              </div>
            )}
            
            <button
              onClick={() => setOpen(!isOpen)}
              className="p-2 hover:bg-accent rounded-lg transition-colors lg:hidden"
            >
              {isOpen ? <X className="h-5 w-5" /> : <ChevronLeft className="h-5 w-5" />}
            </button>
          </div>

          {/* Navigation */}
          <nav className="flex-1 p-4 space-y-1">
            {navigation.map((item) => {
              const Icon = item.icon
              return (
                <NavLink
                  key={item.name}
                  to={item.href}
                  className={({ isActive }) => cn(
                    'flex items-center px-3 py-2 rounded-xl text-sm font-medium transition-colors group',
                    isActive 
                      ? 'bg-primary text-primary-foreground' 
                      : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
                    !isOpen && 'justify-center'
                  )}
                  title={!isOpen ? item.name : undefined}
                >
                  <Icon className={cn('h-5 w-5 flex-shrink-0', isOpen && 'mr-3')} />
                  {isOpen && <span>{item.name}</span>}
                </NavLink>
              )
            })}
          </nav>

          {/* Footer */}
          <div className="p-4 border-t">
            <div className={cn(
              'flex items-center space-x-3 p-3 rounded-xl bg-muted',
              !isOpen && 'justify-center'
            )}>
              <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                <span className="text-primary-foreground text-sm font-medium">A</span>
              </div>
              {isOpen && (
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">Admin User</p>
                  <p className="text-xs text-muted-foreground truncate">admin@thredz.com</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}